type OrganicJobDeliveryClientsListParams = {
  tenantId: string;
  page?: number;
  pageSize?: number;
  integrationName: string;
  clientId?: string | null;
  search?: string;
  moduleStatus?: "active" | "inactive" | null;
  orderBy?: string | null;
  descending?: boolean | null;
};

export const organicJobDeliveryQueryKeys = {
  all: ["integrations"] as const,
  byIntegration: (integrationName: string) =>
    [...organicJobDeliveryQueryKeys.all, integrationName] as const,
  byModule: (integrationName: string) =>
    [...organicJobDeliveryQueryKeys.byIntegration(integrationName), "organic"] as const,
  clients: (integrationName: string) =>
    [...organicJobDeliveryQueryKeys.byModule(integrationName), "clients"] as const,
  clientsList: (params: OrganicJobDeliveryClientsListParams) =>
    [
      ...organicJobDeliveryQueryKeys.clients(params.integrationName),
      params.tenantId,
      params.page,
      params.pageSize,
      params.clientId,
      params.search,
      params.moduleStatus,
      params.orderBy,
      params.descending,
    ] as const,
  vacancies: (integrationName: string) =>
    [...organicJobDeliveryQueryKeys.byModule(integrationName), "vacancies"] as const,
  vacanciesList: (params: {
    integrationName: string;
    clientId: string;
    tenantId: string;
    page?: number;
    pageSize?: number;
    search?: string;
    orderBy?: string | null;
    descending?: boolean | null;
  }) =>
    [
      ...organicJobDeliveryQueryKeys.vacancies(params.integrationName),
      params.clientId,
      params.tenantId,
      params.page,
      params.pageSize,
      params.search,
      params.orderBy,
      params.descending,
    ] as const,
};
